// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"cba2397af3a3d3b0f7cf","453":"39367ef6bb7eb7169fd3"}[chunkId] + ".js";
};